module.exports = __webpack_public_path__ + "img/man-body-front.7561c4d8.png";